import type { CourseModule } from "@/core/types";
import { lektionAnsichten } from "./lektion-01-ansichten";
import { lektionEigenschaften } from "./lektion-02-eigenschaften";
import { lektionMakros } from "./lektion-03-makros";
import { lektionAutokorrektur } from "./lektion-04-autokorrektur";

/**
 * Registerkarte „Ansicht“, Dokumenteigenschaften aus der Backstage-Ansicht,
 * Makros und die AutoKorrektur. Die Ansicht liefert WordApiDesktop 1.4,
 * aufgezeichnete Makros und AutoKorrektur-Einträge nur VBA.
 */
export const modulAnsicht: CourseModule = {
  id: "ansicht",
  title: "Ansichten, Eigenschaften und Makros",
  summary:
    "Gliederungsansicht und Navigationsbereich, Dokumenteigenschaften, aufgezeichnete " +
    "Makros samt Makrosicherheit und eigene AutoKorrektur-Einträge.",
  level: "Aufbau",
  lessons: [lektionAnsichten, lektionEigenschaften, lektionMakros, lektionAutokorrektur],
};
